export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.17-1252.10',
  commitId: 'd804942a5fa1f2a09ab641b45baceba2b39796b6',
  commitTime: '2026-02-17T12:52:10.000Z',
});
